import apiRequest, { apiRequestWithConfig } from '@lib/api-fetch';
import { ClientSafeConfig } from '@lib/context/config-context';
import { fetch_timeout_duration } from '@lib/constants/network-constants';

import { getLogger } from '@lib/util/logging-util';
import { getRuntimeConfig } from '@lib/util/runtime-config-util';

const logger = getLogger();

export async function validateLoginBuyer(
  cart_id: string,
  email: string,
  phone: string,
  currentAmountOfCard: number,
  currentDollarValue: number,
  config?: ClientSafeConfig
): Promise<any> {
  logger.debug('[validateLoginBuyer] Called with cart_id:', cart_id);

  // If cart doesn't exist yet, skip validation (allow first item to be added)
  if (!cart_id || cart_id === 'undefined') {
    logger.debug('[validateLoginBuyer] No cart_id, skipping validation - allowing add to cart');
    return { isValid: true };
  }

  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);

  try {
    const response = await apiRequestWithConfig(
      'POST',
      `/limit/validate-add-to-cart/${cart_id}`,
      {
        body: {
          email,
          phone,
          currentAmountOfCard,
          currentDollarValue,
        },
      },
      '',
      false,
      '',
      fetch_timeout_duration,
      false,
      true,
      runtimeConfig
    );

    // Handle case where response body is null (e.g., HTML error page)
    if (!response.body) {
      console.error('[validateLoginBuyer] No response body - API may be down or returned HTML');
      return {
        isValid: false,
        errorMessage: 'Unable to validate cart. Please try again or contact support.'
      };
    }

    return response.body;
  } catch (error) {
    logger.error('Error validating login buyer:', error);
    // Return a safe default instead of throwing
    return {
      isValid: false,
      errorMessage: 'Unable to validate cart. Please try again or contact support.'
    };
  }
}

export async function passwordLessSend(param: any, config?: ClientSafeConfig): Promise<any> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  return await apiRequestWithConfig(
    'POST',
    `/password-less/send`,
    {
      body: param,
    },
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
}

export async function passwordLessValidate(token: string, config?: ClientSafeConfig): Promise<any> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  return await apiRequestWithConfig(
    'GET',
    `/password-less/validate?token=${token}`,
    {},
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
}

export async function passwordLessCodeValidate(token: string, config?: ClientSafeConfig): Promise<any> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  return await apiRequestWithConfig(
    'POST',
    `/password-less/register/otp`,
    {
      body: { token },
    },
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
}

export async function passwordLessOptValidate(token: string, otp: string, config?: ClientSafeConfig): Promise<any> {
  // Auto-fetch config from window if not provided
  const runtimeConfig = getRuntimeConfig(config);
  return await apiRequestWithConfig(
    'POST',
    `/password-less/register/otp/verify`,
    {
      body: { token, otp },
    },
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
}

export async function hasAccountValidate(email: string, config?: ClientSafeConfig): Promise<any> {
  // Use provided config or auto-fetch from window
  const runtimeConfig = config ?? getRuntimeConfig();
  return await apiRequestWithConfig(
    'GET',
    `/customer/has-account/${email}`,
    {},
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
}

export async function validateLogin(email: string, otp: string, redirect?: string, config?: ClientSafeConfig): Promise<any> {
  // Use provided config or auto-fetch from window
  const runtimeConfig = config ?? getRuntimeConfig();
  return await apiRequestWithConfig(
    'POST',
    `/otp/validate-login`,
    {
      body: { email, otp, redirect },
    },
    '',
    false,
    '',
    fetch_timeout_duration,
    false,
    true,
    runtimeConfig
  );
}